<template lang="html">
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
  };
</script>

<style lang="less">
  @import '~@/styles/index';

  #app {
    min-width: 1200px;
    height: 100%;
    overflow: auto
  }
</style>



// WEBPACK FOOTER //
// App.vue?1f45ae5d